import { useIPortfolio } from './useIPortfolio';
import IPortfolioShell from './IPortfolioShell';
import { PHOTO_ALBUM_IMAGES } from './photoAlbumData';
import './PhotoAlbum.css';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'aos/dist/aos.css';
import 'glightbox/dist/css/glightbox.min.css';
import './main.css';

function PhotoAlbumPage() {
  useIPortfolio();

  return (
    <IPortfolioShell activeSection="personal-interests">
      <section id="photo-album" className="photo-album section light-background">
        <div className="container section-title" data-aos="fade-up">
          <h2>Photo Album</h2>
          <p>Real snapshots from travel, friendships, and everyday moments.</p>
        </div>

        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="photo-album-grid">
            {PHOTO_ALBUM_IMAGES.map((photo, index) => (
              <a
                key={photo.caption}
                href={photo.src}
                className="glightbox photo-album-item"
                data-gallery="photo-album-gallery"
                data-glightbox={`description: ${photo.caption}`}
                data-aos="fade-up"
                data-aos-delay={Math.min(50 + index * 40, 300)}
              >
                <img src={photo.src} alt={photo.caption} loading="lazy" />
                <div className="photo-album-caption">
                  <p>{photo.caption}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </IPortfolioShell>
  );
}

export default PhotoAlbumPage;
